/* Focusring alleen voor het toetsenbord.

   Na een tik of klik tekende de browser soms een vierkante ring om het
   element dat je net aanraakte of om het element dat na het openen van een
   paneel de focus kreeg (kruisje, logo, terugknop, maattabel, accordeon).
   Dat hoort niet bij bedienen met een vinger of muis.

   Dit script onthoudt hoe er het laatst bediend is en zet dat op <html>:
   `is-pointer` na een tik of klik, weg zodra iemand met Tab of de pijltjes
   door de pagina gaat. theme.css zet onder `is-pointer` elke focusring uit.
   Toetsenbordgebruikers houden de ring gewoon, want daar weten ze mee waar
   ze zijn.

   Daarnaast verhuist na het openen van de cart drawer en het mobiele menu
   de focus bij aanwijzergebruik naar het paneel zelf. Dat paneel heeft
   tabindex="-1", dus de focus blijft binnen de dialoog en de eerstvolgende
   Tab landt op het eerste element.

   Het staat als los bestand naast theme.js en laadt direct daarna (beide
   defer, dus in volgorde). Het leest alleen de classes die theme.js al zet
   (`is-open`, `is-sub-open`) en raakt de logica daar niet aan. */

(function () {
  'use strict';

  var root = document.documentElement;
  var navigationKeys = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'];

  /* Standaard aanwijzer: de meeste bezoekers tikken. De eerste Tab zet de
     ring meteen terug. */
  var keyboard = false;
  root.classList.add('is-pointer');

  document.addEventListener('keydown', function (event) {
    if (navigationKeys.indexOf(event.key) === -1) return;
    keyboard = true;
    root.classList.remove('is-pointer');
  }, true);

  document.addEventListener('pointerdown', function () {
    keyboard = false;
    root.classList.add('is-pointer');
  }, true);

  function watch(dialog, panel) {
    if (!dialog || !panel) return;
    new MutationObserver(function () {
      if (keyboard) return;
      var open = dialog.classList.contains('is-open');
      var active = document.activeElement;
      if (!open || !active || active === panel || !dialog.contains(active)) return;
      try {
        panel.focus({ preventScroll: true });
      } catch (error) {
        panel.focus();
      }
      /* Zelfde reden als in theme.js: .cart-drawer is een scrollcontainer
         en een focus kan hem een stukje opzij schuiven. */
      dialog.scrollLeft = 0;
    }).observe(dialog, { attributes: true, attributeFilter: ['class'] });
  }

  var cart = document.getElementById('CartDrawer');
  watch(cart, cart && cart.querySelector('[data-cart-drawer-panel]'));

  var nav = document.querySelector('.mobile-nav--js');
  watch(nav, nav);
})();
